import React from 'react';
import styled from '@emotion/styled';
import { withNamespaces } from 'react-i18next';
import cn from 'classnames';

import styles from './style.css';
import Popover from '../popover';
import Notifications from 'modules/advocate-notifications/export';
import { qaSel } from '../../common/utils';

const NotificationsPopoverContainer = styled('div')`
  width: 350px;
  border-radius: 5px;
  overflow: hidden;
`;

class NotificationOverlay extends React.Component {
  state = {
    popoverOpen: false,
  };

  handleClick = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  handleClickOutside = () => {
    this.setState({ popoverOpen: false });
  };

  /* eslint complexity: 0 */
  render() {
    const { overlayAdjustments, toggleSeen, children, t, moment } = this.props;
    return (
      <div className={cn(styles.container, 'c-action-center-link c-notifications')}>
        <button
          data-qa={qaSel('link-notifications')}
          className={cn(styles.iconLink, 'c-button c-button-icon')}
          ref={node => this.notifications = node}
          aria-label={t('Access your last notifications')}
          onClick={e => {
            this.handleClick(e);
            toggleSeen();
          }}>
          {children}
        </button>
        <Popover
          target={this.notifications}
          show={this.state.popoverOpen}
          onHide={this.handleClickOutside}
          {...overlayAdjustments}>
          <NotificationsPopoverContainer className="c-notification-container">
            <Notifications t={t} moment={moment} />
          </NotificationsPopoverContainer>
        </Popover>
      </div>
    );
  }
}

export default withNamespaces()(NotificationOverlay);
